module.exports = __webpack_public_path__ + "img/Sharepoint.b574c27f.svg";